export const LEGAL = {
  company: "Alliance Web AH L.L.C.",
  site: "ah2020.fr",
  siteUrl: "https://ah2020.fr",
  appUrl: "https://alliancemanif.fr",
  email: "antoine@ah2020.fr",
  host: "IONOS Inc., 701 Lee Road, Suite 300, Chesterbrook, PA 19087, USA",
  updated: "15 octobre 2026",
};
